import styled from "styled-components";

const TermsConditionStyleWrapper = styled.section`
  padding: 110px 0; 
  background: #0d102d;

  .terms_condition_content {
    margin: 0 auto;
    h3 {
      font-size: 26px;
      line-height: 46px;
      color: #ffffff;
      margin-bottom: 20px;
    }

    p {
      font-size: 16px;
      line-height: 26px;
      color: rgba(255, 255, 255, 0.8);
    }
  }


  @media only screen and (max-width: 912px) {
    padding: 80px 0;

    .terms_condition_content {
      h3 {
        font-size: 22px;
        line-height: 40px;
      }

      p {
        font-size: 15px;
        line-height: 25px;
      }
    }
  }

  @media only screen and (max-width: 568px) {
    padding: 60px 0;
    
    .terms_condition_content {
      h3 {
        font-size: 20px;
        line-height: 36px;
      }

      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
`;

export default TermsConditionStyleWrapper;
